import styled from 'styled-components';

export const MainButton = styled.button`
    align-items: center;
    background: var(--info);
    border: none;
    border-radius: 40px;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 1px 5px 0 rgba(0,0,0,0.12), 0 3px 1px -2px rgba(0,0,0,0.2);
    color: white;
    display: flex;
    flex-direction: column;
    height: 40px;
    justify-content: center;
    position: fixed;
    right: 40px;
    top: 140px;
    transition: .2s;
    width: 40px;

    & i{
        font-size: 20px;
        transition: .2s;
    }

    &:hover{
        cursor: pointer;
        height: 80px;
        right: 20px;
        top: 120px;
        width: 80px;
    }

    &:hover i{
        font-size: 36px;
    }

    &:focus{
        outline: none;
    }

    & span{
        display: none;
        font-size: 11px;
        text-transform: uppercase;
    }

    &:hover span{
        display: block;
    }
`;

export const VideoContainer = styled.div`
    background: rgba(0, 0, 0, 0.84);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    bottom: 12px;
    padding: 4px;
    position: fixed;
    right: 12px;
    transition: .5s;
    z-index: 9999;


    & .header{
        padding: 12px;
        text-align: right;
    }

    & .header i{
        color: white;
        font-weight: bold;
        margin-left: 12px;
    }

    & .header i:hover{
        cursor: pointer;
        color: var(--gray);
    }

    & .body iframe{
        height: 240px;
        width: 320px;
    }

    &.maximized{
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        left: 0;
        position: absolute;
        top:0;
        z-index: 999999;
    }

    &.maximized .body{
        padding: 18px;
        position: relative;
    }
    &.maximized .body iframe{
        height: calc(100vh - 160px);
        width: 100%;
    }
`;